'use client';

import { SESSION_REPLAY_MASK_CLASS } from '@/lib/forms/privacy';

import styles from './RepairDetailsContactSummary.module.scss';

interface RepairDetailsContactSummaryProps {
  email: string;
  phoneNumber: string;
}

export function RepairDetailsContactSummary({
  email,
  phoneNumber,
}: Readonly<RepairDetailsContactSummaryProps>) {
  return (
    <div className={styles.wrapper} data-testid="repair-details-contact-summary">
      <p className={`${styles.line} ${SESSION_REPLAY_MASK_CLASS}`}>{email}</p>
      {phoneNumber ? (
        <p className={`${styles.line} ${SESSION_REPLAY_MASK_CLASS}`}>{phoneNumber}</p>
      ) : null}
    </div>
  );
}
